// src/utils/constantes.js

export const OPCOES_DEFICIENCIA = [
    { label: 'NENHUM', value: 'NENHUM' },
    { label: 'DA - DEFICIÊNCIA AUDITIVA', value: 'DEFICIENCIA_AUDITIVA' },
    { label: 'DV - DEFICIÊNCIA VISUAL', value: 'DEFICIENCIA_VISUAL' },
    { label: 'DI - DEFICIÊNCIA INTELECTUAL', value: 'DEFICIENCIA_INTELECTUAL' },
    { label: 'DM - DEFICIÊNCIA MOTORA', value: 'DEFICIENCIA_MOTORA' },
    { label: 'TEA - AUTISMO', value: 'AUTISMO_TEA' },
    { label: 'TDAH - DÉFICIT DE ATENÇÃO', value: 'TDAH' },
    { label: 'TOD - TRANSTORNO OPOSITOR DESAFIADOR', value: 'TOD' },
    { label: 'TAG - ANSIEDADE GENERALIZADA', value: 'TAG' },
    { label: 'SD - SÍNDROME DE DOWN', value: 'SINDROME_DE_DOWN' },
    { label: 'ST - SÍNDROME DE TOURETTE', value: 'SINDROME_TOURETTE' },
    { label: 'OUTROS', value: 'OUTROS' }
];

export const TIPOS_PERFIL = ['INSCRITO', 'ALUNO', 'INSTRUTOR', 'ADMIN'];